import { Features } from '../const/features'

export const checkFeature = (features: string[], requiredFeature: Features) => {
  return features.includes(requiredFeature)
}
